<div class="p-fluid p-formgrid cas-flex-row">
    <div class="p-field p-col-12 p-md-4">
        <label for="restricted-solution">Organisation</label>
        <p-dropdown id="restricted-solution" inputId="restricted-solution" [options]="organisations" [(ngModel)]="selectedOrganisation"
                    optionLabel="name"></p-dropdown>
    </div>
</div>
